<template>
    <!-- Container START -->
    <div>
        <div class="container">
            <div class="row g-4">
                <!-- Main content START -->
                <div class="col-lg-8 mx-auto" style="direction: rtl;">
                    <Header pageTitle="سياسة الخصوصية" />
                    <!-- Privacy & terms START -->
                    <div class="card" style="margin-top: 70px;">
                        <div class="card-header">
                            <p style="font-weight: bold;font-size: large;" class="card-title mb-0">سياسة الخصوصية</p>
                        </div>
                        <div class="card-body">
                            <!-- مقدمة -->
                            <p><strong>سياسة الخصوصية لتطبيق "إتقان"</strong></p>
                            <p><strong>تاريخ النفاذ:</strong> [أدخل التاريخ]</p>
                            <hr class="mt-2 mb-4">
                            <p><strong>1. مقدمة</strong></p>
                            <p>
                                نحن في تطبيق "إتقان" نُقدّر خصوصيتك ونلتزم بحماية بياناتك الشخصية. تهدف هذه السياسة إلى توضيح كيفية جمعنا واستخدامنا ومشاركة معلوماتك عند استخدامك للتطبيق أو الخدمات المرتبطة به. يُشكّل استخدامك للتطبيق موافقةً على هذه السياسة.
                            </p>
                            <hr class="mt-2 mb-4">
                            <p><strong>2. المعلومات التي نجمعها</strong></p>
                            <p><strong>أ. المعلومات التي تقدمها مباشرةً:</strong></p>
                            <ul>
                                <li>البيانات الشخصية: مثل الاسم، البريد الإلكتروني، رقم الهاتف، الصورة الشخصية، المهارات المهنية، السيرة الذاتية.</li>
                                <li>بيانات الدفع: مثل معلومات البطاقة الائتمانية (تُعالج عبر بوابات دفع آمنة ولا نخزنها على خوادمنا).</li>
                                <li>المحتوى الذي تُنشره: مثل المنشورات، التعليقات، المشاريع، التقييمات.</li>
                            </ul>
                            <p><strong>ب. المعلومات التي نجمعها تلقائيًا:</strong></p>
                            <ul>
                                <li>بيانات الاستخدام: مثل الصفحات التي تزورها، المدة، الأجهزة المستخدمة (نظام التشغيل، نوع المتصفح).</li>
                                <li>الموقع الجغرافي: إذا سمحت بالإذن، نستخدمه لعرض الخدمات القريبة منك.</li>
                                <li>الكوكيز (Cookies): لتحسين تجربتك وتذكر تفضيلاتك.</li>
                            </ul>
                            <hr class="mt-2 mb-4">
                            <p><strong>3. كيف نستخدم معلوماتك؟</strong></p>
                            <ul>
                                <li>توفير الخدمات: كتوصيل المستقلين بالعملاء، إدارة المشاريع، ومعالجة الدفعات.</li>
                                <li>تحسين التطبيق: مثل تحليل سلوك المستخدمين لتطوير الميزات.</li>
                                <li>التواصل معك: كإرسال إشعارات حول المشاريع، التحديثات، أو العروض الترويجية (يمكنك إلغاء الاشتراك في أي وقت).</li>
                                <li>الأمان: منع الاحتيال أو الانتهاكات.</li>
                            </ul>
                            <hr class="mt-2 mb-4">
                            <p><strong>4. مشاركة المعلومات مع أطراف ثالثة</strong></p>
                            <ul>
                                <li>مقدمو الخدمات: مثل شركات الدفع (PayPal، Stripe) أو مزودي الاستضافة، بشرط التزامهم بمعايير الخصوصية.</li>
                                <li>الالتزام القانوني: نكشف عن المعلومات إذا تطلب القانون أو لحماية حقوقنا.</li>
                                <li>الشركاء التجاريين: مثل الجهات التي تتعاون مع "إتقان" لتقديم عروض مُخصصة (بموافقتك).</li>
                            </ul>
                            <hr class="mt-2 mb-4">
                            <p><strong>5. حماية البيانات</strong></p>
                            <ul>
                                <li>نستخدم تقنيات تشفير (SSL/TLS) لحماية البيانات المنقولة.</li>
                                <li>نحدد صلاحيات الوصول إلى البيانات للحد من التعرض للاختراقات.</li>
                                <li>نلتزم بمعايير أمان الصناعة مثل <strong>ISO 27001</strong>.</li>
                            </ul>
                            <hr class="mt-2 mb-4">
                            <p><strong>6. حقوقك في بياناتك</strong></p>
                            <ul>
                                <li>الوصول: يمكنك طلب نسخة من بياناتك الشخصية.</li>
                                <li>التصحيح: يمكنك تعديل المعلومات غير الدقيقة.</li>
                                <li>الحذف: يمكنك طلب حذف حسابك وبياناتك (مع استثناءات كالبيانات المطلوبة قانونيًا).</li>
                                <li>الاعتراض: يمكنك إيقاف استخدام بياناتك لأغراض تسويقية.</li>
                            </ul>
                            <p>للمطالبة بهذه الحقوق، راسلنا عبر: [البريد الإلكتروني للدعم].</p>
                            <hr class="mt-2 mb-4">
                            <p><strong>7. الاحتفاظ بالبيانات</strong></p>
                            <p>
                                نحتفظ ببياناتك طالما كان حسابك نشطًا أو للفترة اللازمة لتحقيق الأهداف المذكورة في هذه السياسة، ما لم يتطلب القانون الاحتفاظ بها لفترة أطول.
                            </p>
                            <hr class="mt-2 mb-4">
                            <p><strong>8. خصوصية الأطفال</strong></p>
                            <p>
                                لا نستهدف مستخدمين دون <strong>16 عامًا</strong>. إذا اكتشفنا جمع بيانات قاصر دون موافقة ولي الأمر، سنحذفها فورًا.
                            </p>
                            <hr class="mt-2 mb-4">
                            <p><strong>9. التغييرات على السياسة</strong></p>
                            <p>
                                نحتفظ بالحق بتحديث هذه السياسة. سنعلمك عبر الإشعارات داخل التطبيق أو البريد الإلكتروني قبل التغييرات الجوهرية.
                            </p>
                            <hr class="mt-2 mb-4">
                            <p><strong>10. الاتصال بنا</strong></p>
                            <p>
                                لأية استفسارات حول الخصوصية، راسلنا عبر:
                                <br> البريد الإلكتروني: <strong>info@itqan-app.com</strong>
                            </p>
                        </div>
                    </div>
                    <!-- Privacy & terms END -->
                </div>
            </div> <!-- Row END -->
        </div> <!-- Row END -->
        <Footer />
    </div>
    <!-- Container END -->
</template>

<script>
import Header from "../../components/header.vue";
import Footer from "../../components/footer.vue";
export default {
    components: {
        Header,
        Footer,
    },
};
</script>

<style scoped></style>
